module.exports = __webpack_public_path__ + "static/img/chejia_case.888f38b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Homepage/chejia_case.png
// module id = ny5Z
// module chunks = 19